<section id="contact">
    <div class="box-white">
        <div class="wrapper padding-all">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="">
                        <div class="table-responsive">
                            <table id="example1" class="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>S.N.</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let user of data; let i=index">
                                        <td>{{i+1}}</td>
                                        <td><span style="white-space: pre-wrap">{{user.nmpk_suggestionDesc}}</span> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
